<template>
  <div class="text-h6">オフセット</div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>トップ</div>
      <div class="text-caption">offsetTop</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.offsetTop"
      :rules="[
        (val) => offsetValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in offsetList"
              clickable
              v-close-popup
              :key="index"
              @click="value.offsetTop = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>ボトム</div>
      <div class="text-caption">offsetBottom</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.offsetBottom"
      :rules="[
        (val) => offsetValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in offsetList"
              clickable
              v-close-popup
              :key="index"
              @click="value.offsetBottom = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>スタート</div>
      <div class="text-caption">offsetStart</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.offsetStart"
      :rules="[
        (val) => offsetValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in offsetList"
              clickable
              v-close-popup
              :key="index"
              @click="value.offsetStart = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>エンド</div>
      <div class="text-caption">offsetEnd</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.offsetEnd"
      :rules="[
        (val) => offsetValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in offsetList"
              clickable
              v-close-popup
              :key="index"
              @click="value.offsetEnd = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageButton,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageText,
} from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Offset extends Vue {
  @Prop()
  modelValue!: IFlexMessageText | IFlexMessageBox | IFlexMessageButton | IFlexMessageImage | IFlexMessageIcon

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageText | IFlexMessageBox | IFlexMessageButton | IFlexMessageImage | IFlexMessageIcon) {
    this.$emit('update:modelValue', value)
  }

  get offsetList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  offsetValidate(val) {
    if (!val) return true

    const isPxOrPercent = /^-?\d+(\.\d+)?(px|%)$/.test(val)
    const isKeyword = this.offsetList.includes(val)
    return isPxOrPercent || isKeyword
  }
}
</script>

<style scoped lang="scss">

</style>
